import React from 'react';
import { Info } from 'lucide-react';
import { calculateForumScore } from '../utils/forumScore';
import type { ForumBase } from '../types/forum';

interface Props {
  forum: ForumBase;
  darkMode: boolean;
}

const ForumScoreExplainer: React.FC<Props> = ({ forum, darkMode }) => {
  const topics = forum.topics_count || 0;
  const posts = forum.posts_count || 0;
  const members = forum.members_count || 0;
  const year = forum.founded_year || 1;
  const raw = topics * 5 + posts * 2 + members * 10;
  const score = calculateForumScore(topics, posts, members, year);

  return (
    <div
      className={`rounded-lg p-4 text-sm ${
        darkMode ? 'bg-indigo-900/30 border border-indigo-800 text-indigo-100' : 'bg-indigo-50 border border-indigo-100 text-indigo-900'
      }`}
    >
      <div className="flex items-start gap-2">
        <Info size={18} className="shrink-0 mt-0.5" />
        <div>
          <p className="font-semibold mb-2">Forum skoru nasıl hesaplanır?</p>
          <p className={`mb-2 ${darkMode ? 'text-indigo-200' : 'text-indigo-800'}`}>
            (Konu × 5) + (İleti × 2) + (Üye × 10), sonuç kuruluş yılına ({year}) bölünür.
          </p>
          <p className="font-mono text-xs opacity-90">
            ({topics.toLocaleString('tr-TR')}×5 + {posts.toLocaleString('tr-TR')}×2 +{' '}
            {members.toLocaleString('tr-TR')}×10) ÷ {year} ={' '}
            <strong>{score.toLocaleString('tr-TR')}</strong>
            <span className="opacity-70"> (ham: {raw.toLocaleString('tr-TR')})</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForumScoreExplainer;
